import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "checkinWrapper",
  class: "flex-col"
}
const _hoisted_2 = { class: "flex-row" }
const _hoisted_3 = {
  key: 0,
  class: "content flex-col"
}
const _hoisted_4 = { class: "logo-hdr" }
const _hoisted_5 = {
  key: 0,
  class: "img-wrapper flex-center"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "def-client-name bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gutter" }, null, -1)),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
            _createElementVNode("header", _hoisted_4, [
              (_ctx.logoUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", { src: _ctx.logoUrl }, null, 8, _hoisted_6)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.clientName ?? ''), 1))
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
              : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
          ]))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gutter" }, null, -1))
    ])
  ]))
}